export const promotionConstants = {
  PROMOTION_ITEMS_REQUEST: 'PROMOTION_ITEMS_REQUEST',
  PROMOTION_ITEMS_SUCCESS: 'PROMOTION_ITEMS_SUCCESS',
  PROMOTION_ITEMS_FAILURE: 'PROMOTION_ITEMS_FAILURE',

  RANDOM_PROMO_PRODUCT_REQUEST: 'RANDOM_PROMO_PRODUCT_REQUEST',
  RANDOM_PROMO_PRODUCT_SUCCESS: 'RANDOM_PROMO_PRODUCT_SUCCESS',
  RANDOM_PROMO_PRODUCT_FAILURE: 'RANDOM_PROMO_PRODUCT_REQUEST',
};
